import { Component, OnInit, inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import {
	ItButtonDirective,
	ItInputComponent,
	ItSelectComponent,
} from 'design-angular-kit';
import { DossierComponent } from '../dossier/dossier.component';
import { TranslateModule } from '@ngx-translate/core';
import { IterlexService } from '../iterlex.service';
import type { Authority } from '../interfaces/authority';
import type { Dossier } from '../interfaces/dossier';
import type { DossierType } from '../interfaces/dossier-type';

@Component({
	selector: 'app-search-page',
	imports: [
		DossierComponent,
		ItButtonDirective,
		ItInputComponent,
		ItSelectComponent,
		FormsModule,
		TranslateModule,
	],
	templateUrl: './search-page.component.html',
	styleUrl: './search-page.component.scss',
})
export class SearchPageComponent implements OnInit {
	private iterlexService = inject(IterlexService);

	authorities: Authority[] = [];
	dossierTypes: DossierType[] = [];
	dossiers: Dossier[] = [];
	dossierStates = ['InProgress', 'Sended', 'Transferred', 'Archived'];
	ngOnInit(): void {
		this.iterlexService.getProfile().subscribe((profile) => {
			this.iterlexService.getAuthorities().subscribe((authorities) => {
				if (profile.roles.some((role) => role.name == 'Admin')) {
					this.authorities = authorities;
				} else {
					for (const authority of authorities) {
						if (
							profile.roles.some(
								(role) =>
									role.name.split('|')[0] == authority.id,
							)
						) {
							this.authorities.push(authority);
						}
					}
				}
			});
		});
	}
	getDossierType(dossierTypeId: string) {
		return this.dossierTypes.find((e) => e.id == dossierTypeId);
	}
	onSearchSubmit(form: NgForm) {
		if (form.valid) {
			const [authority, body] = form.value.authority.split('/');
			this.iterlexService
				.getDossierTypes(
					new HttpParams()
						.append('authority', authority)
						.append('body', body),
				)
				.subscribe((dossierTypes) => {
					this.dossierTypes = dossierTypes;
					const params = new HttpParams()
						.append('authority', authority)
						.append('body', body)
						.append('title', form.value.title)
						.append('number', form.value.number)
						.append('year', form.value.year)
						.append('state', form.value.state);
					this.iterlexService
						.getDossiers(params)
						.subscribe(
							(dossiers) => (this.dossiers = dossiers.value),
						);
				});
		}
	}
}
